import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import template from './right-side-description.vue';

@Component({
    mixins: [template],
})
export default class RightSideDescription extends Vue {
    @Prop(Object) readonly auctionData!: any;

    created() {}

    protected get currentLot() {
        const currentLot = this.auctionData.lots[this.$store.state.currentShownLot]

        const tehnica = currentLot.attributes.find((item: any) => item.name === 'Material / Tehnica')
        const dimensiuni = currentLot.attributes.find((item: any) => item.name === 'Dimensiuni')
        currentLot.dimensiuni = dimensiuni ? dimensiuni.value : ''
        currentLot.tehnica = tehnica ? tehnica.value : ''

        return currentLot
    }

    mounted() {}
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/components/right-side-description/index.ts